import { render, staticRenderFns } from "./EditarItensLoteLicitacao.vue?vue&type=template&id=f5eed1a8&scoped=true"
import script from "./EditarItensLoteLicitacao.vue?vue&type=script&lang=ts"
export * from "./EditarItensLoteLicitacao.vue?vue&type=script&lang=ts"
import style0 from "./EditarItensLoteLicitacao.vue?vue&type=style&index=0&id=f5eed1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eed1a8",
  null
  
)

export default component.exports